import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Approved from '../views/approved.vue'
import Declined from '../views/declined.vue'

Vue.use(VueRouter);

  const routes = [
  {
    path: '*',
    name: 'home',
    component: Home
  },
  {
    path: '*/approved/:id',
    name: 'Approved',
    component: Approved
  },
  {
    path: '*/declined/:id',
    name: 'Declined',
    component: Declined
  }
];


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router
